import { c as _c } from "react/compiler-runtime";
import { SortType } from "@website/accommodation-ui/tour-result-header/tour-sort-view/types";
import { useToggle } from "@website/utils/use-toggle/useToggle";
import { useRouter } from "next/router";
import { SORT_OPTIONS } from "./types";
interface Properties {
  orderBy: string;
  sorts: Array<SortType>;
}
export const useTourSortView = t0 => {
  const $ = _c(13);
  const {
    orderBy,
    sorts
  } = t0;
  const router = useRouter();
  const {
    query
  } = router;
  const orderByValue = query?.[orderBy];
  const [open, toggleOpen] = useToggle(false);
  let t1;
  if ($[0] !== orderBy || $[1] !== query || $[2] !== router || $[3] !== toggleOpen) {
    t1 = function onChangeRadio(response) {
      toggleOpen();
      router.push({
        query: {
          ...query,
          [orderBy]: response.target.value
        }
      }, undefined, {
        shallow: true
      });
    };
    $[0] = orderBy;
    $[1] = query;
    $[2] = router;
    $[3] = toggleOpen;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onChangeRadio = t1;
  let t2;
  if ($[5] !== orderByValue || $[6] !== sorts) {
    t2 = orderByValue ? sorts.find(element => element.value === orderByValue) : sorts.find(_temp);
    $[5] = orderByValue;
    $[6] = sorts;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const activeSort = t2;
  let t3;
  if ($[8] !== activeSort || $[9] !== onChangeRadio || $[10] !== open || $[11] !== toggleOpen) {
    t3 = {
      onChangeRadio,
      open,
      activeSort,
      toggleOpen
    };
    $[8] = activeSort;
    $[9] = onChangeRadio;
    $[10] = open;
    $[11] = toggleOpen;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
function _temp(s) {
  return s.value === SORT_OPTIONS.RECOMMENDED || s.value === SORT_OPTIONS.SUGGESTED;
}